import { CoinsEffect } from "./CoinsEffect";

export class CoinsEffectPool extends Phaser.GameObjects.Container {
    // private coinFrame: string;
    private coinsEffects: CoinsEffect[];
    // private end: { x: number, y: number } = { x: 0, y: 0 }

    constructor(scene: Phaser.Scene, numCoinsEffect: number, frame: string, end: { x: number, y: number }, start: { x: number, y: number }) {
        super(scene)
        this.scene = scene;
        // this.coinFrame = frame;

        this.scene = scene;
        this.coinsEffects = [];
        // this.end = end;

        for (let i = 0; i < numCoinsEffect; i++) {
            const coinsEffect = new CoinsEffect(this.scene, frame, end, start, { min: 100, max: 200 });
            this.coinsEffects.push(coinsEffect);
            this.add(coinsEffect)
        }
    }

    showTime() {
        this.coinsEffects.forEach(coin => coin.action())
    }
}
